const stepperData = [
  "施設選択",
  "対象施設一覧／施設情報・異動状況登録",
  "内容確認",
  "機構へ提出",
];

/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "処理状況",
  },
  {
    headTitle: "施設情報",
  },
  {
    headTitle: "職員の異動状況",
  },
  {
    headTitle: "削除",
  },
];

export { headTitleList, stepperData };
